var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 15.7C3.74995 15.7 0.324951 12.25 0.324951 8.00001C0.324951 3.75001 3.74995 0.325012 7.99995 0.325012C12.25 0.325012 15.7 3.75001 15.7 8.00001C15.7 12.25 12.25 15.7 7.99995 15.7ZM7.99995 1.20001C4.24995 1.20001 1.19995 4.25001 1.19995 8.00001C1.19995 11.75 4.24995 14.825 7.99995 14.825C11.75 14.825 14.825 11.75 14.825 8.00001C14.825 4.25001 11.75 1.20001 7.99995 1.20001Z",
    fill: "#11BD60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15005 9.75C6.97505 9.75 6.82505 9.7 6.67505 9.575L5.02505 7.975C4.85005 7.8 4.85005 7.525 5.02505 7.35C5.20005 7.175 5.47505 7.175 5.65005 7.35L7.15005 8.825L10.35 5.725C10.525 5.55 10.8 5.55 10.975 5.725C11.15 5.9 11.15 6.175 10.975 6.35L7.65005 9.6C7.47505 9.7 7.30005 9.75 7.15005 9.75Z",
    fill: "#11BD60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a5f8748817d75823d4466c2f70911cc3.svg";
export { ForwardRef as ReactComponent };